var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6676 14.7059C31.1854 14.6052 25.2807 14.4659 17.0117 14.4912C16.3739 14.5202 15.7361 14.5491 15.2971 14.9343C14.593 15.5141 14.4564 16.5246 14.4066 17.4399C13.9965 24.4887 13.1349 31.6494 13.1804 38.6776C13.1555 40.1395 13.8347 41.0217 14.4766 41.0838C20.722 41.8957 27.5597 41.6763 33.863 41.7551C36.5136 41.8173 46.4822 42.186 47.9069 41.3909C48.9713 40.7034 48.8637 38.3345 48.9134 37.4192C49.1933 31.9909 49.1481 26.5492 49.1586 20.9656",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4804 29.5578C51.208 29.5879 53.0031 29.6293 54.8998 29.6852C55.9062 29.7308 57.012 29.9544 57.509 30.8449C57.803 31.288 57.7367 31.8388 57.7574 32.2944C57.6993 39.0534 57.8276 45.8951 57.4879 52.4843C57.4381 53.3996 57.5458 55.7685 56.4814 56.456C55.0567 57.2511 45.0881 56.8824 42.4375 56.8202C36.1341 56.7414 29.2965 56.9608 23.0511 56.1489C22.4091 56.0868 21.73 55.2046 21.7548 53.7427C21.7422 51.789 21.7997 49.8251 21.898 47.8562",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0873 18.1265C31.7191 17.9861 25.3817 18.1486 17.9988 18.0996C17.5555 24.4196 17.2282 31.2821 17.0583 37.5896C25.2047 38.0412 31.2306 38.0413 35.5295 38.2111C37.6292 38.207 44.968 38.9692 45.0011 37.6895C45.1379 34.6703 45.1006 31.8417 45.1918 27.8203C45.2167 25.3571 45.1811 22.6918 45.1113 20.3987",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0725 33.1975C50.5174 33.2225 52.0234 33.2565 53.6059 33.3021C53.7249 35.9216 53.798 39.5388 53.7635 42.7988C53.6707 46.7856 53.7068 49.5899 53.5689 52.583C53.5353 53.8518 46.1969 53.099 44.0972 53.1039C39.7985 52.9372 33.7727 52.9394 25.6266 52.495C25.6689 50.9636 25.7205 49.3992 25.781 47.8177",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9869 33.398C42.2411 31.2402 39.4994 29.1735 36.6625 27.0199C36.0041 26.5933 35.3414 26.0756 34.5255 26.2039C34.2563 26.3075 34.0782 26.4069 33.809 26.5104C32.7405 27.1068 30.8188 29.0201 29.5391 28.987C27.986 28.9662 27.166 26.9948 25.4432 27.2557C24.8095 27.3758 24.1841 27.6781 23.5629 28.0716C21.517 29.2602 19.471 30.4487 17.4293 31.7284",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4449 21.2323C26.4888 22.0981 26.4847 24.0161 25.0555 24.7203C23.8914 25.2298 22.396 24.4758 22.2469 23.2041C22.1102 22.2057 22.7896 21.079 23.788 20.9423C24.2395 20.8305 25.0638 20.8843 25.4449 21.2323Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4258 28.2578C29.8396 29.5168 28.3942 29.8564 27.0606 30.6474",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5112 24.8915C12.2311 24.8763 11.0495 24.7779 9.39827 24.8233C7.83795 24.8764 5.84589 24.6189 4.56583 25.702C3.96746 26.2928 3.80084 27.1942 3.82357 28.0198C3.64183 32.3978 3.74034 36.7076 3.37681 41.0704C3.25563 42.5247 3.2708 43.4412 3.32383 45.0015C3.34657 46.9254 4.74784 47.6828 8.13358 47.6904C18.1772 47.9781 24.7517 48.1598 33.9243 47.9173C35.121 47.834 35.8179 47.1599 36.0072 45.9859L35.9924 42.6975",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0753 44.7543C23.5767 44.6786 12.7756 44.6939 8.31434 44.4137C7.95077 44.3834 7.5872 44.3531 7.24635 44.0501C6.81461 43.7396 6.77673 43.0958 6.8146 42.6413C6.89787 38.3466 7.15535 33.0597 7.32952 28.7726C7.34466 28.5908 7.35981 28.4091 7.46585 28.2349C7.57189 28.0606 7.84457 28.0834 8.03392 28.0076C9.96539 27.894 12.1544 27.9849 13.3511 27.9015",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.913 44.4624C29.6793 43.8138 26.4703 43.5164 19.9141 41.8936",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9083 43.6005C29.6823 43.1209 26.4771 42.908 19.9376 41.6514",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4494 20.1546C47.1769 20.6382 46.6868 20.3994 44.5227 20.055C41.3931 19.5569 39.4666 17.7157 39.4924 14.8872C39.5165 12.2417 41.5675 10.3701 44.1214 10.1227C45.4146 7.90828 47.9704 6.20936 50.7009 6.23425C53.5002 6.25976 55.9206 7.85682 57.1464 10.1876C58.8435 10.696 60.0368 12.0327 60.4314 13.7483C60.7183 14.9957 60.8288 16.4545 60.1508 17.5848C59.3108 18.9851 57.5228 20.0333 55.4494 20.1546Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2676 21.1172C47.297 21.4948 47.0611 21.4476 49.0902 21.7307",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8397 14.0336L48.7173 16.2359L53.112 11.9047",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6841 45.5049L46.5904 46.8587C45.3045 47.1444 43.9642 47.0615 42.7234 46.6195L35.8098 44.1568",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBackup);
export default __webpack_public_path__ + "static/media/cloud-backup.16dea5a337d7ac7be1e85dab9385e1b3.svg";
export { ForwardRef as ReactComponent };